export type DataObject = {
    type: string,
    name: string,
    size: string,
    label: string,
    hint: string,
    id: string,
    value: string,
}

export function createDataObject(element: any, iter?: number): DataObject {
    if(iter == null){
        return{
            type: element.type,
            name: element.name ?? "",
            size: element.size ?? "",
            label: element.label ?? "",
            hint: element.hint ?? "",
            id: element.id ?? "",
            value: element.value ?? ""
        }
    }else{
        return{
            type: element.type,
            name: (element.name ?? "").replace(/{iter}/g,iter + ""),
            size: element.size ?? "",
            label: (element.label ?? "").replace(/{iter}/g,iter + ""),
            hint: (element.hint ?? "").replace(/{iter}/g,iter + ""),
            id: (element.id ?? "").replace(/{iter}/g,iter + ""),
            value: element.value ?? ""
        }
    }
}

